module.exports = __webpack_public_path__ + "img/75593.026051e1.svg";